var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_168518",
    "data-name": "Group 168518",
    transform: "translate(0.318 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_19708",
    "data-name": "Rectangle 19708",
    transform: "translate(-0.318 0)",
    fill: "rgba(92,93,103,0)",
    stroke: "#4b8aeb",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 37,
    height: 37,
    rx: 7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-refresh",
    "data-name": "Icon ionic-md-refresh",
    d: "M15.1,22.209a7.107,7.107,0,0,1,0-14.215,6.885,6.885,0,0,1,4.976,2.132l-3.791,3.791h8.292V5.625L21.794,8.409a9.464,9.464,0,1,0,2.428,9.277H21.716A7.058,7.058,0,0,1,15.1,22.209Z",
    transform: "translate(4.08 4.398)",
    fill: "#4b8aeb"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.9b36f9724e407e0cb7469f88633b0073.svg";
export { ForwardRef as ReactComponent };